import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { ThemeProvider } from "./lib/theme";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import Platform from "./pages/Platform";
import Manufacturing from "./pages/Manufacturing";
import HowItWorks from "./pages/HowItWorks";
import Partners from "./pages/Partners";
import About from "./pages/About";
import Contact from "./pages/Contact";
import InstantQuote from "./pages/InstantQuote";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import CustomerLogin from "./pages/CustomerLogin";
import CustomerRegister from "./pages/CustomerRegister";
import CustomerPortal from "./pages/CustomerPortal";
import AuthCallback from "./pages/AuthCallback";
import PartnerLogin from "./pages/PartnerLogin";
import PartnerRegister from "./pages/PartnerRegister";
import PartnerPortal from "./pages/PartnerPortal";
import ProductUnderstanding from "./pages/ProductUnderstanding";
import ResetPassword from "./pages/ResetPassword";
import "./App.css";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const AppRoutes = () => {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Synchronous fragment check (before protected routes) per Emergent Auth playbook.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/platform" element={<Platform />} />
      <Route path="/manufacturing" element={<Manufacturing />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      <Route path="/partners" element={<Partners />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/quote" element={<InstantQuote />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/rfqs/:id/understanding" element={<ProductUnderstanding adminView />} />
      <Route path="/portal/login" element={<CustomerLogin />} />
      <Route path="/portal/register" element={<CustomerRegister />} />
      <Route path="/portal" element={<CustomerPortal />} />
      <Route path="/portal/rfqs/:id/understanding" element={<ProductUnderstanding />} />
      <Route path="/partner/login" element={<PartnerLogin />} />
      <Route path="/partner/register" element={<PartnerRegister />} />
      <Route path="/partner" element={<PartnerPortal />} />
      <Route path="/reset-password" element={<ResetPassword />} />
    </Routes>
  );
};

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App">
          <Header />
          <main className="pt-16 sm:pt-20">
            <AppRoutes />
          </main>
          <Footer />
        </div>
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
